module.exports = __webpack_public_path__ + "static/media/sf_3200_gray.fbe6f7a631edbcf2a70c0d1b72886265.png";